import { FormEventHandler, KeyboardEvent, RefObject } from 'react'
import { PaperAirplaneIcon } from '@heroicons/react/24/outline'

type ChatAssistantComposerProps = {
    draft: string
    onDraftChange: (value: string) => void
    onSubmit: FormEventHandler<HTMLFormElement>
    textareaRef: RefObject<HTMLTextAreaElement>
    isSendDisabled: boolean
}

export default function ChatAssistantComposer({
    draft,
    onDraftChange,
    onSubmit,
    textareaRef,
    isSendDisabled
}: ChatAssistantComposerProps) {
    return (
        <form
            onSubmit={onSubmit}
            className="flex flex-col gap-4 sm:flex-row sm:items-end"
        >
            <label className="flex-1">
                <span className="sr-only">Message</span>
                <textarea
                    value={draft}
                    onChange={(event) => onDraftChange(event.target.value)}
                    onKeyDown={(event: KeyboardEvent<HTMLTextAreaElement>) => {
                        if (event.key === 'Enter' && !event.shiftKey) {
                            event.preventDefault()
                            if (!isSendDisabled) {
                                event.currentTarget.form?.requestSubmit()
                            }
                        }
                    }}
                    ref={textareaRef}
                    rows={3}
                    placeholder="Chat here..."
                    className="block w-full rounded-md border-0 py-3 px-4 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:text-sm sm:leading-6"
                />
            </label>
            <button
                type="submit"
                disabled={isSendDisabled}
                className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-600 px-5 py-3 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-500"
            >
                <PaperAirplaneIcon aria-hidden className="h-4 w-4" />
                Send
            </button>
        </form>
    )
}
